import { render, staticRenderFns } from "./SkuDataTable.vue?vue&type=template&id=17b91244"
import script from "./SkuDataTable.vue?vue&type=script&lang=js"
export * from "./SkuDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports